// client/src/components/Experience.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Experience() {
  const experiences = [
    {
      logoText: 'BMW',
      logoColor: '#3fae63',
      company: 'BMW Group TechWorks Brasil',
      companySuffix: 'powered by act digital',
      role: 'Full Stack Engineer',
      employment: 'Full-time',
      duration: 'May 2026 - Present · 4 mos',
      location: 'São Paulo, Brazil · Hybrid',
      bullets: [
        'Atuação no desenvolvimento de soluções em arquitetura de micro frontends, criando componentes escaláveis e otimizados para aprimorar a experiência digital do cliente.',
        'Participação na estruturação da área de experiência digital do cliente, contribuindo como desenvolvedor Full Stack na implementação, evolução e otimização de APIs com foco em performance e qualidade.',
        'Desenvolvimento e manutenção de aplicações em Micro Frontend com Angular, entregando novas funcionalidades com base em requisitos de negócio.',
        'Integração entre frontend e backend via MuleSoft e C#, com foco em performance e qualidade.',
        'Colaboração com times internacionais (EUA, México e outros países) na resolução de desafios técnicos complexos.',
        'Correções de UI e otimizações de performance em projetos de grande escala.',
      ],
      skills: ['Angular', 'MuleSoft', 'C#', 'Micro Frontends'],
    },
    {
      logoText: 'Q',
      logoColor: '#1a1f2e',
      company: 'Qonta',
      role: 'Junior Software Engineer',
      employment: 'Full-time',
      duration: 'Nov 2025 - May 2026 · 7 mos',
      location: 'São Paulo, Brazil · Hybrid',
      bullets: [
        'Design and maintain event-driven backend services in C#/.NET, processing asynchronous workflows via AWS Lambda at production scale.',
        'Architect and manage cloud data storage — DynamoDB tables for multi-pattern access and S3 buckets for structured document handling with object-level resolution.',
        'Own cloud infrastructure end-to-end using Infrastructure as Code (IaC): Lambdas, DynamoDB, and S3 provisioned and versioned through YAML templates.',
        'Integrate PostgreSQL for relational data operations, handling complex queries and transactional inserts within distributed service workflows.',
        'Monitor system health and debug production incidents using Amazon CloudWatch — reducing mean time to resolution through structured log analysis.',
      ],
      skills: ['AWS Lambda', 'DynamoDB', 'PostgreSQL', 'C#/.NET'],
    },
    {
      logoText: 'BB',
      logoColor: '#ffe000',
      logoTextColor: '#1a1f2e',
      company: 'Best Buy',
      role: 'Computer Sales Advisor',
      employment: 'Full-time',
      duration: 'Nov 2023 - April 2025',
      bullets: [
        'Provided technical support, troubleshooting, and guidance to customers on various computer-related issues.',
      ],
    },
    {
      logoText: 'PW',
      logoColor: '#78C3FB',
      logoTextColor: '#1a1f2e',
      company: 'Freelance - Premium Wraps FL',
      role: 'Freelance Web Developer',
      duration: 'Dec 2022 - Feb 2023',
      bullets: [
        "I led a team of two individuals in the development of a website for an automotive dealership in Florida. The client commissioned the project with the objective of enhancing the dealership's visibility and increasing the volume of vehicle orders.",
      ],
    },
    {
      logoText: 'JSF',
      logoColor: '#0d6efd',
      company: 'Justa Soluções Financeiras',
      role: 'Data Scientist Junior',
      duration: 'Oct 2021 - Aug 2022',
      bullets: [
        'I conducted data analysis for the logistics department of the company. Through data analysis, automation of several manual processes was also implemented using bots and web scraping tools in Python. As a result of process automation, the company was able to save over 30,000 BRL (approximately 6,000 USD) due to the loss of card machines and paper rolls. Additionally, the automation of manual processes resulted in a 50% reduction in work time.',
      ],
    },
  ];

  return (
    <Container>
      <h1 className='text-white title-work text-center'>
        <i className="bi bi-briefcase-fill me-2"></i>
        Work Experience
      </h1>
      <div className="horizontal-line"></div>
      <Row>
        {experiences.map((exp, index) => (
          <Col key={index} md={12} className="mb-4">
            <div className="work-experience">
              <div
                className="work-experience-logo"
                style={{ background: exp.logoColor, color: exp.logoTextColor || '#fff' }}
              >
                {exp.logoText}
              </div>

              <div className="work-experience-body">
                <h5 className="text-white work-experience-role">{exp.role}</h5>
                <p className="work-experience-company">
                  {exp.company}
                  {exp.companySuffix ? ` · ${exp.companySuffix}` : ''}
                  {exp.employment ? ` · ${exp.employment}` : ''}
                </p>
                <p className="work-experience-meta">
                  <i className="bi bi-calendar3 me-2"></i>{exp.duration}
                </p>
                {exp.location && (
                  <p className="work-experience-meta">
                    <i className="bi bi-geo-alt-fill me-2"></i>{exp.location}
                  </p>
                )}

                <ul className="work-experience-bullets">
                  {exp.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>

                {exp.skills && (
                  <div className="work-experience-skills">
                    {exp.skills.map((skill) => (
                      <span key={skill} className="work-experience-skill-tag">{skill}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {index < experiences.length - 1 && <div className="horizontal-line"></div>}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Experience;
